<template>
  <div class="arrowPosition">
    <span @click="goToPreviousPage" class="defaultHeader__back">
      <font-awesome-icon :icon="['fas', 'chevron-left' ]" />
      {{$t('general.back')}}
    </span>
    <div v-if="showmodal == true" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div>
            <h1 class="modalTitle">{{$t('general.backModalTitle')}}</h1>
            <p class="modalText">{{$t('general.backModalText')}}</p>
          </div>
          <div class="d-flex">
            <button
              @click="choiceModal(false)"
              class="btn btn-outline-primary btn-block mt-4 mr-2"
            >{{$t('general.cancell')}}</button>
            <button
              @click="choiceModal(true)"
              class="btn btn-primary btn-block mt-4 ml-2"
            >{{$t('raportModal.confirm')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['shouldShowModal'],
  data() {
    return {
      showmodal: false
    };
  },
  methods: {
    goToPreviousPage() {
      this.shouldShowModal ? (this.showmodal = true) : this.$router.go(-1);
    },
    choiceModal(choice) {
      choice == true ? this.$router.go(-1) : (this.showmodal = false);
    }
  }
};
</script>

<style lang="scss" scoped>
.defaultHeader__back {
  z-index: 999999999999;
}
.arrowPosition {
  position: fixed;
  z-index: 999899;
  top: 0px;
}

.modal-mask {
  position: fixed;
  z-index: 999899;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  z-index: 999999999999999;
  width: 95%;
  max-width: 450px;
  margin: 0px auto;
  padding: 20px 15px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modalTitle {
  margin-top: 0;
  font-size: 22px;
  text-align: center;
}
.modalText {
  text-align: center;
  font-size: 15px;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>